import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import FundingRequestField from './FundingRequestField';
import InvestmentFormStatus from './InvestmentFormStatus';
import { formatCurrency } from '@utils/common';
import { INVESTMENT_STATUS } from '@api/investments';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

type FundingRequestAdjustmentDetailsCardProps = {
  fundingRequestDetails: any;
  downloadAttachment?: (attachmentIndex: number) => void;
  attachments?: any;
};

const FundingRequestAdjustmentDetailsCard: React.FC<FundingRequestAdjustmentDetailsCardProps> = ({
  fundingRequestDetails,
  downloadAttachment,
  attachments,
}) => {
  return (
    <>
      {fundingRequestDetails ? (
        <Box
          sx={{
            backgroundColor: 'white',
            padding: '1rem',
            borderRadius: '0.5rem',
            marginTop: '1.25rem',
          }}
        >
          <Typography
            sx={{
              fontWeight: '700',
              fontSize: '1rem',
              lineHeight: '1.25rem',
              color: '#6C6C6C',
              mb: '2rem',
            }}
          >
            Adjustment Request
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '1.875rem',
            }}
          >
            <FundingRequestField
              name="New Growth Spend"
              value={formatCurrency(fundingRequestDetails?.actualSpend || 0) || ''}
            />
            <FundingRequestField
              name="New Investment Amount"
              value={
                formatCurrency(
                  fundingRequestDetails?.actualSpend * fundingRequestDetails?.fundingPercentage ||
                    0,
                ) || ''
              }
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '1.875rem',
            }}
          >
            <FundingRequestField
              name={`${
                fundingRequestDetails?.allocatedAdjustment > 0 ||
                fundingRequestDetails?.requestedAdjustment > 0
                  ? 'Overspent'
                  : 'Underspent'
              } Amount (${fundingRequestDetails?.adjustmentSettlementDate || fundingRequestDetails?.settlementDate})`}
              value={
                formatCurrency(
                  Math.abs(
                    fundingRequestDetails?.allocatedAdjustment
                      ? fundingRequestDetails.allocatedAdjustment
                      : fundingRequestDetails?.requestedAdjustment,
                  ) || 0,
                ) || ''
              }
            />
          </Box>
          {![
            INVESTMENT_STATUS.APPROVED,
            INVESTMENT_STATUS.CLOSED,
            INVESTMENT_STATUS.REJECTED,
            INVESTMENT_STATUS.REJECTED_ADJUSTMENT,
          ].includes(fundingRequestDetails.status) &&
            fundingRequestDetails?.fundingAdjustmentReported && (
              <InvestmentFormStatus
                currentStatus={fundingRequestDetails.status}
                isAdjustment={true}
              />
            )}
          {attachments.length > 1 ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0.625rem',
                backgroundColor: '#f4f4f4',
                borderRadius: '0.5rem',
                width: '300px',
                mt: '1rem',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
              >
                <InsertDriveFileOutlinedIcon
                  sx={{
                    color: '#36736d',
                    width: '2rem',
                    height: '2rem',
                  }}
                />
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      fontSize: '0.75rem',
                      lineHeight: '1rem',
                      color: '#6C6C6C',
                    }}
                  >
                    Adjustment Request Form
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 500,
                      fontSize: '0.75rem',
                      lineHeight: '1rem',
                      color: '#B4B4B4',
                    }}
                  >
                    Download Available
                  </Typography>
                </Box>
              </Box>
              <IconButton
                onClick={() => downloadAttachment && downloadAttachment(1)}
                sx={{ color: '#36736d' }}
              >
                <DownloadOutlinedIcon />
              </IconButton>
            </Box>
          ) : (
            <></>
          )}
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

export default FundingRequestAdjustmentDetailsCard;
